import api from './api';

export type ComputerPlatform = 'windows' | 'macos' | 'linux' | 'other';
export interface ComputerInput {
  name: string;
  rustdeskId: string;
  platform: ComputerPlatform;
  groupName: string;
  clientName: string;
  notes: string;
  favorite: boolean;
  password?: string;
  clearPassword?: boolean;
}
export interface RemoteComputer extends ComputerInput { id: string; hasPassword: boolean; }

export const remoteComputerService = {
  list: async (): Promise<RemoteComputer[]> => (await api.get('/remote-computers')).data.data,
  create: async (data: ComputerInput): Promise<RemoteComputer> => (await api.post('/remote-computers', data)).data.data,
  update: async (id: string, data: ComputerInput): Promise<RemoteComputer> => (await api.put(`/remote-computers/${encodeURIComponent(id)}`, data)).data.data,
  remove: async (id: string): Promise<void> => { await api.delete(`/remote-computers/${encodeURIComponent(id)}`); },
  connect: async (id: string): Promise<{ rustdeskId: string; password: string | null }> =>
    (await api.post(`/remote-computers/${encodeURIComponent(id)}/connect`)).data.data,
};
